import React, { useCallback, useState, useEffect } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { Layout } from 'antd';
// import * as jsonwebtoken from 'jsonwebtoken';
// import jsonwebtoken from 'jsonwebtoken';
import jwtDecode from 'jwt-decode';

import Header from 'src/components/Header';
import Navigation from 'src/components/Navigation';
import Loading from 'src/components/common/Loading';

import { useQueryProxy } from 'src/operations/proxy/user';
import { USER_ME } from 'src/operations/queries/getUser';
import { isLogedIn, userInfoVar } from 'src/apollo/cache';
import { getCurrentToken } from '../utils';
import { storage } from 'src/utils/hooks';

const { Content } = Layout;

function DefaultLayout({ component: Component, logOut, isHeaderStatic = false, closeHeader = false, ...rest }) {
  const history = useHistory();

  const token = getCurrentToken();

  const [collapsed, setCollapsed] = useState(false);
  const [initiallyLoadedMeToken, setInitiallyLoadedMeToken] = useState(null);
  const hasCompletedInitialMeLoad = Boolean(token && initiallyLoadedMeToken === token);

  const { loading, data, refetch } = useQueryProxy(USER_ME, {
    variables: { token },
    skip: !token,
    notifyOnNetworkStatusChange: false,
    onError(error) {
      isLogedIn(false);
      if (history.location.pathname !== '/login') {
        history.replace('/login');
      }
    },
  });

  useEffect(() => {
    if (data?.me || (!loading && token)) {
      setInitiallyLoadedMeToken(token);
    }
  }, [data?.me, loading, token]);

  // useEffect(() => {
  //   if (!isLogedIn()) {
  //     history.push('/login');
  //   }

  //   if (data?.me) {
  //     userInfoVar(data?.me);
  //   } else {
  //     userInfoVar(jsonwebtoken.decode(storage.getItem('culp_token')) && null);
  //   }
  // }, [data, history, loading, token]);
  useEffect(() => {
    if (!isLogedIn() || !token) {
      if (history.location.pathname !== '/login') {
        history.replace('/login');
      }
    }
  }, [history, token]);

  useEffect(() => {
    if (data?.me) {
      userInfoVar(data?.me);
      // setLoaded(true);
    } else if (token) userInfoVar(jwtDecode(token));
  }, [data, loading, token]);

  useEffect(() => {
    const checkSessionOnFocus = () => {
      const currentToken = getCurrentToken();

      if (!currentToken) {
        isLogedIn(false);
        if (history.location.pathname !== '/login') {
          history.replace('/login');
        }
        return;
      }

      refetch({ token: currentToken }).catch(() => {
        // The query's onError handler redirects to login.
      });
    };

    window.addEventListener('focus', checkSessionOnFocus);
    return () => window.removeEventListener('focus', checkSessionOnFocus);
  }, [history, refetch]);


  const onCollapse = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  if (!token || !isLogedIn()) {
    return <Redirect to="/login" />;
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <>
          {!hasCompletedInitialMeLoad && loading ? (
            <Loading />
          ) : (
            <Layout>
              {collapsed && <Navigation />}
              <Layout>
                <Header collapsed={collapsed} onCollapse={onCollapse} isStatic={isHeaderStatic} closeHeader={closeHeader} />
                <Content style={{ margin: '0 16px' }}>
                  <Component {...matchProps} {...rest} />
                </Content>
              </Layout>
            </Layout>
          )}
        </>
      )}
    />
  );
}

export default DefaultLayout;
